const VALORANT_MEDIA = 'https://media.valorant-api.com';

const IMAGE_FIELDS = [
  'img',
  'image',
  'icon',
  'banner',
  'card',
  'displayIcon',
  'displayIcon2',
  'fullRender',
  'verticalPromoImage',
  'largeArt',
  'wideArt',
  'smallArt',
  'fullPortrait',
  'bustPortrait',
  'killfeedPortrait',
  'largeIcon',
  'smallIcon',
  'fullTransparentIcon',
];

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const isUuidLike = (value) => UUID_RE.test(String(value || '').trim());

export const normalizeImageUrl = (value) => {
  if (typeof value !== 'string') return '';
  const text = value.trim();
  if (!text || text === 'undefined' || text === 'null' || text === '[object Object]') return '';
  if (text.startsWith('data:') || text.startsWith('blob:')) return text;
  if (text.startsWith('//')) return `https:${text}`;
  if (text.startsWith('http://')) return `https://${text.slice('http://'.length)}`;
  if (text.startsWith('https://') || text.startsWith('/')) return text;
  if (text.startsWith('media.valorant-api.com/') || text.startsWith('valorant-api.com/')) {
    return `https://${text}`;
  }
  return '';
};

export const valorantMediaUrl = (category, id, file = 'displayicon.png') => {
  if (!isUuidLike(id)) return '';
  return `${VALORANT_MEDIA}/${category}/${id}/${file}`;
};

export const resolveImageSrc = (source, fallback = '') => {
  if (Array.isArray(source)) {
    for (const item of source) {
      const src = resolveImageSrc(item);
      if (src) return src;
    }
    return normalizeImageUrl(fallback);
  }

  const direct = normalizeImageUrl(source);
  if (direct) return direct;

  if (source && typeof source === 'object') {
    for (const field of IMAGE_FIELDS) {
      const src = resolveImageSrc(source[field]);
      if (src) return src;
    }
  }

  return normalizeImageUrl(fallback);
};

export const resolveSkinImageSrc = (item = {}) => (
  resolveImageSrc(item) ||
  valorantMediaUrl('weaponskinlevels', item.level_id || item.levelId, 'displayicon.png') ||
  valorantMediaUrl('weaponskins', item.id, 'displayicon.png')
);

export const resolveAgentImageSrc = (item = {}) => (
  resolveImageSrc(item) ||
  valorantMediaUrl('agents', item.id, 'displayicon.png')
);

export const resolveRankImageSrc = (item = {}) => {
  const tier = Number(item.tier);
  if (Number.isFinite(tier) && tier >= 0) {
    return resolveImageSrc(item) ||
      `${VALORANT_MEDIA}/competitivetiers/03621f52-342b-cf4e-4f86-9350a49c6d04/${tier}/largeicon.png`;
  }
  return resolveImageSrc(item);
};

export const resolveCardImageSrc = (item = {}) => (
  resolveImageSrc(item) ||
  valorantMediaUrl('playercards', item.id, 'smallart.png')
);

export const resolveBuddyImageSrc = (item = {}) => (
  resolveImageSrc(item) ||
  valorantMediaUrl('buddies', item.id, 'displayicon.png')
);

export const resolveBundleImageSrc = (bundle = {}) => (
  resolveImageSrc(bundle) ||
  resolveImageSrc(bundle.items || [])
);
